import { render, staticRenderFns } from "./TemperatureBl.vue?vue&type=template&id=39ec088a&scoped=true&"
import script from "./TemperatureBl.vue?vue&type=script&lang=js&"
export * from "./TemperatureBl.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureBl.vue?vue&type=style&index=0&id=39ec088a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec088a",
  null
  
)

/* custom blocks */
import block0 from "./TemperatureBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports